import React from "react";
import { CatalogSectionData } from "../../hooks/useProductCatalog";
import CatalogProductCard from "../CatalogProductCard/CatalogProductCard";

interface CatalogSectionProps {
  section: CatalogSectionData;
}

export default function CatalogSection({ section }: CatalogSectionProps) {
  const { category, products } = section;

  return (
    <section aria-label={category.name}>
      <div className="mb-4">
        <p className="text-xs text-gray-400 dark:text-gray-500">
          {products.length} {products.length === 1 ? "product" : "products"}
        </p>
        <h2 className="mt-0.5 text-base font-normal text-gray-900 dark:text-white">
          {category.name}
        </h2>
        {category.tagline && (
          <p className="text-sm text-gray-500 dark:text-gray-400">
            {category.tagline}
          </p>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {products.map((product) => (
          <CatalogProductCard key={product.slug} product={product} />
        ))}
      </div>
    </section>
  );
}
